import { render, staticRenderFns } from "./type_1.vue?vue&type=template&id=692aca1e&scoped=true"
import script from "./type_1.vue?vue&type=script&lang=js"
export * from "./type_1.vue?vue&type=script&lang=js"
import style0 from "./type_1.vue?vue&type=style&index=0&id=692aca1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692aca1e",
  null
  
)

export default component.exports